import script from "./Positions.vue?vue&type=script&setup=true&lang=js"
export * from "./Positions.vue?vue&type=script&setup=true&lang=js"

import "./Positions.vue?vue&type=style&index=0&id=0571e4a9&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0571e4a9"]])

export default __exports__